/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';
import modulesService from './../../services/modules';

export default {
  data() {
    return {
      form: new Forms({}),
      loading: false,
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },

  mounted() {
    const me = this;
    me.loading = true;
    const fields = {};
    for (let i = 0; i < me.module.fields.length; i++) {
      const new_field = {
        type: me.module.fields[i].type || 'text',
        value: '',
      };
      fields[me.module.fields[i].name] = new_field;
    }

    me.form = new Forms(fields);
    me.loading = false;
  },

  watch: {

  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Fetch the component's required resources.
     */
    getResources() {

    },

    store() {
      this.form.loading = true;
      const obj = Object.assign({ module_id: this.module.id }, this.form.data());
      modulesService.subscribe(this.module.id, obj)
      .then(() => {
        modulesService.items().then((data) => {
          this.closeModal();
        });
      })
      .catch((error) => {
        const message = error.data ? error.data.message : 'Field Required';
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
        this.form.recordErrors(error);
        this.form.loading = false;
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/subscribeModal/subscribeModal.js